import { render, staticRenderFns } from "./SellerStats.vue?vue&type=template&id=505b2e30&scoped=true"
import script from "./SellerStats.vue?vue&type=script&lang=js"
export * from "./SellerStats.vue?vue&type=script&lang=js"
import style0 from "./SellerStats.vue?vue&type=style&index=0&id=505b2e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b2e30",
  null
  
)

export default component.exports